<template>
    <main class="main-content main-404">
        <div class="container">
            <div class="row aligment-responsive">
                <div class="col-12 col-lg-6 content-404">
                    <h1>Ops! </h1>
                    <h2>Ocorreu um erro ao tentar acessar a página. Tente novamente mais tarde.</h2>
                    <a href="">Ir para a homepage</a>
                </div>
                <div class="col-12 col-lg-6">
                    <img class="img-404" src="@/assets/images/404.png" alt="">
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'Error',
    head: {
        title:{
            inner:'Não encontrado'
        }
    }
}
</script>